import { render } from "./SyslogSettings.vue?vue&type=template&id=0f0104ca&ts=true"
import script from "./SyslogSettings.vue?vue&type=script&lang=ts"
export * from "./SyslogSettings.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\Users\\jenkinsuser\\AppData\\Local\\Jenkins\\.jenkins\\workspace\\UI\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__